/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class MaterialProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Material by ID
	 * @param {String|Number} pMaterialID - The Material ID to search for=
	 * @return {Promise<void>}
	 * @async
	 */
	getMaterialByID(pMaterialID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pMaterialID)
			{
				this.pict.log.error('No Material ID provided.');
				return reject(new Error('No Material ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Material/${pMaterialID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Material: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Materials
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	async getMaterials()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'Materials';

			// Check if we need to filter by customer ID
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `Materials/By/IDCustomer/${this.pict.AppData.DocumentData.ReportData.IDCustomer}`;
			}

			// Make the request to get materials
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Materials list.', pError);
					reject(pError);
				}
				else
				{
					resolve(pBody);
				}
			});
		});
	}
}

module.exports = MaterialProvider;
module.exports.default_configuration = {};
